module.exports = __webpack_public_path__ + "Flaticon.73df0fc3bcc73cf0af3b.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.woff
// module id = ../../../../../src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.woff
// module chunks = styles